const downloadButtonsPresent = () => {
  return $("#pdf_layout_dimension_lines_included").length > 0;
};

export default downloadButtonsPresent;
